import api from './api';

const studentService = {
  // Register Student - Submit complete registration
  registerStudent: async (studentData) => {
    try {
      const response = await api.post('/students/register', studentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get student by ID
  getStudentById: async (id) => {
    try {
      const response = await api.get(`/students/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get student by registration ID
  getStudentByRegistrationId: async (registrationId) => {
    try {
      const response = await api.get(`/students/registration/${registrationId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get all students (Admin only)
  getAllStudents: async () => {
    try {
      const response = await api.get('/students');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Update student
  updateStudent: async (id, studentData) => {
    try {
      const response = await api.put(`/students/${id}`, studentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Delete student (Admin only)
  deleteStudent: async (id) => {
    try {
      const response = await api.delete(`/students/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get dashboard stats
  getDashboardStats: async () => {
    try {
      const response = await api.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Search students by name (Admin only)
  searchStudents: async (name) => {
    try {
      const response = await api.get(`/students/search?name=${name}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Get students by status (Admin only)
  getStudentsByStatus: async (status) => {
    try {
      const response = await api.get(`/students/status/${status}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Update student status (Admin only)
  updateStudentStatus: async (id, status) => {
    try {
      const response = await api.patch(`/students/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Admission APIs
  confirmAdmission: async (admissionData) => {
    try {
      const response = await api.post('/admissions/confirm', admissionData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  getAdmissionByStudentId: async (studentId) => {
    try {
      const response = await api.get(`/admissions/student/${studentId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  getAllAdmissions: async () => {
    try {
      const response = await api.get('/admissions');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },



    // ================= PHOTO APIs =================

  // Upload student photo
  uploadPhoto: async (id, file) => {
    try {
      const formData = new FormData();
      formData.append('photo', file);

      const response = await api.post(`/students/${id}/photo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  getDocumentUrl: (id, path) => {
    if (!path) return '';
    const token = localStorage.getItem('token');
    const tokenParam = token ? `&token=${encodeURIComponent(token)}` : '';
    return `https://web.omkarahostel.com/OmkaraHostel/students/${id}/document?path=${encodeURIComponent(path)}${tokenParam}`;
    //return `https://web.omkarahostel.com/api/students/${id}/document?path=${encodeURIComponent(path)}${tokenParam}`;
  },

  getPhotoUrl: (id, forceRefresh = false) => {
    if (!id) return '';
    const token = localStorage.getItem('token');
    const tokenParam = token ? `?token=${encodeURIComponent(token)}` : '';
    const refresh = forceRefresh ? `&t=${new Date().getTime()}` : '';
    return `https://web.omkarahostel.com/OmkaraHostel/students/${id}/photo${tokenParam}${refresh}`;
    //return `https://web.omkarahostel.com/api/students/${id}/photo${tokenParam}${refresh}`;
  },

  // Fetch image/doc as blob and return object URL — use this for <img> tags
  fetchImageAsBlob: async (url) => {
    if (!url) return null;
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      if (!res.ok) {
        console.warn(`AuthImage fetch failed: ${res.status} ${res.statusText} — ${url}`);
        return null;
      }
      const blob = await res.blob();
      if (!blob || blob.size === 0) {
        console.warn(`AuthImage: empty blob from ${url}`);
        return null;
      }
      return URL.createObjectURL(blob);
    } catch (err) {
      console.warn(`AuthImage fetch error: ${err.message} — ${url}`);
      return null;
    }
  },

  // Upload ID proof documents (aadhar, passport, drivingLicense)
  uploadIdProofs: async (id, files) => {
    try {
      const formData = new FormData();
      // Front/back files
      if (files.aadharFront)         formData.append('aadharFront',         files.aadharFront);
      if (files.aadharBack)          formData.append('aadharBack',          files.aadharBack);
      if (files.drivingLicenseFront) formData.append('drivingLicenseFront', files.drivingLicenseFront);
      if (files.drivingLicenseBack)  formData.append('drivingLicenseBack',  files.drivingLicenseBack);
      if (files.passportFront)       formData.append('passportFront',       files.passportFront);
      if (files.passportBack)        formData.append('passportBack',        files.passportBack);
      if (files.panFront)            formData.append('panFront',            files.panFront);
      if (files.panBack)             formData.append('panBack',             files.panBack);
      if (files.lightBill)           formData.append('lightBill',           files.lightBill);
      // Legacy fallback keys
      if (files.aadhar && !files.aadharFront)        formData.append('aadhar',         files.aadhar);
      if (files.drivingLicense && !files.drivingLicenseFront) formData.append('drivingLicense', files.drivingLicense);
      if (files.passport && !files.passportFront)    formData.append('passport',       files.passport);
      if (files.pan && !files.panFront)              formData.append('pan',            files.pan);

      const response = await api.post(`/students/${id}/id-proofs`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Update ID proof documents for an existing student (used in edit flow)
  updateIdProofs: async (id, files) => {
    return studentService.uploadIdProofs(id, files);
  },

  // Delete student photo
  deletePhoto: async (id) => {
    try {
      const response = await api.delete(`/students/${id}/photo`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

};

export default studentService;